import React, {
  memo, useCallback, useContext, useEffect, useRef, useState,
} from 'react';
import {connect, useDispatch} from 'react-redux';
import PropTypes from 'prop-types';
import SidebarNav from './SidebarNav';
import SidebarUser from './SidebarUser';
import {ROUTES} from '../../configs/routes';
import {ActionRouteNavigate} from '../../store/actions/actions-route';
import {ActionToggleSidebar, ActionPagesUpdateState} from '../../store/actions/actions-pages';
import {SidebarBurgerArrow, SidebarBurgerLine} from '../SvgComponents/SvgComponents';
import './Sidebar.less';
import {LanguageContext} from '../../context/LanguageContext';

function Sidebar({hideSidebar}) {
  const language = useContext(LanguageContext);

  const [hide, setHide] = useState(hideSidebar);

  const sidebarRef = useRef();

  const dispatch = useDispatch();

  const toggleSidebar = useCallback(() => {
    dispatch(ActionToggleSidebar());
  }, []);

  const onLogoClick = useCallback(() => {
    dispatch(ActionRouteNavigate(ROUTES.ROOT.route));
  }, []);

  const [xDown, setXDown] = useState(null);

  const handleTouchStart = useCallback((evt = {}) => {
    const firstTouch = evt.touches[0];
    setXDown(firstTouch.clientX);
  }, []);

  const handleTouchMove = useCallback((evt) => {
    if (!sidebarRef.current.contains(evt.target)) {
      return;
    }
    const xUp = evt.touches[0].clientX;
    const xDiff = xDown - xUp;

    if (Math.abs(xDiff) > 120 && (xDiff > 0)) {
      dispatch(ActionPagesUpdateState('hideSidebar', true));
    }
  }, [xDown]);

  useEffect(() => {
    setHide(hideSidebar);
  }, [hideSidebar]);

  useEffect(() => {
    sidebarRef.current.addEventListener('touchstart', handleTouchStart, false);
    sidebarRef.current.addEventListener('touchmove', handleTouchMove, false);
    return () => {
      sidebarRef.current.removeEventListener('touchstart', handleTouchStart, false);
      sidebarRef.current.removeEventListener('touchmove', handleTouchMove, false);
    };
  }, [xDown]);

  return (
    <div
      ref={sidebarRef}
      className={`sidebar ${hide ? 'sidebar--hidden' : ''} custom-scroll-small`}
    >
      <div className="sidebar__header">
        <div
          role="button"
          className="sidebar__logo"
          onClick={onLogoClick}
        />
        <button type="button" className="burger-button" onClick={toggleSidebar}>
          <SidebarBurgerLine />
          <SidebarBurgerArrow className={hide ? 'closed' : ''} />
          <span className="burger-button__close">+</span>
        </button>
      </div>
      <div className="sidebar__tagline__wrap">
        <div className={`sidebar__tagline ${language}`} />
      </div>
      <SidebarUser />
      <SidebarNav />
    </div>
  );
}

Sidebar.defaultProps = {
  hideSidebar: false,
};

Sidebar.propTypes = {
  hideSidebar: PropTypes.bool,
};

function mapStateToProps({rPages}) {
  return {
    hideSidebar: rPages.hideSidebar,
  };
}

export default connect(mapStateToProps, null)(memo(Sidebar));
